module.exports = __webpack_public_path__ + "assets/wpmu-dev-smush.1eab76b1.svg";